export const hearingIncludes = {
  contents: 'Contents',
  contentTypes: 'Contents.ContentType',
  userHearingRoles: 'UserHearingRoles',
  userInvitationSourceMappings: 'UserHearingRoles.InvitationSourceMappings',
  companyHearingRoles: 'CompanyHearingRoles',
  companyIncitationSourceMappings:
    'CompanyHearingRoles.InvitationSourceMappings',
};

export const commentIncludes = {
  contents: 'Contents',
  contentTypes: 'Contents.ContentType',
  commentDeclineInfo: 'CommentDeclineInfo',
};

export const hearingTemplateIncludes = {
  fields: 'Fields',
  fieldTemplates: 'Fields.FieldTemplates',
  fieldTypeSpecification: 'Fields.FieldType.FieldTypeSpecifications',
  validationRules: 'Fields.ValidationRule',
};
